import type { ITheme } from '../../../utils/theme';

export const getCounterColor = (
  hasError: boolean,
  disabled: boolean,
  theme: ITheme
) => {
  if (disabled) {
    return theme.palette.neutral['70'];
  }
  if (hasError) {
    return theme.palette.error.main;
  }
  return theme.palette.neutral['90'];
};

export const getIconColor = (
  hasError: boolean,
  disabled: boolean,
  theme: ITheme
) => {
  if (hasError) {
    return theme.palette.error.main;
  }
  if (disabled) {
    return theme.palette.neutral['70'];
  }
  return theme.palette.primary.main;
};

export const getLabelColor = (hasError: boolean, theme: ITheme) => {
  if (hasError) {
    return theme.palette.error.main;
  }
  return theme.palette.neutral['100'];
};
